import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="footer-cc">
      <div className="footer-cc__top">
        <div className="footer-cc__top-left">
          {/* Cien Cuadras logo removed from here */}
          <div className="footer-cc__contact-info">
            <span>#923</span>
            <span>601 3905331</span>
            <span>reclamaciones@ciencuadras.com</span>
            <a href="https://comunicaciones.ciencuadras.com/ley2300" target="_blank" rel="noopener noreferrer">Canales de preferencia</a>
          </div>
        </div>
        {/* Social media icons section removed */}
      </div>
      <div className="footer-cc__bottom">
        <div className="footer-cc__links">
          <a href="https://novedades.ciencuadras.com/politica-de-cookies/" target="_blank" rel="noopener noreferrer">Políticas de Cookies</a>
          <a href="https://www.ciencuadras.com/terminos-y-condiciones" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a>
          <a href="https://www.ciencuadras.com/politicas-de-datos-personales" target="_blank" rel="noopener noreferrer">Política de Tratamiento de Datos Personales</a>
          <a href="https://www.sic.gov.co/" target="_blank" rel="noopener noreferrer">Vigilado Superintendencia de Industria y Comercio (SIC)</a>
        </div>
        <p className="footer-cc__copyright">
          Ciencuadras 2023 © - Servicios Bolívar S.A. NIT: 900.311.092-7. Dirección de notificaciones: Av. Cl 26 # 69 76 Bogotá D.C.
        </p>
      </div>
    </footer>
  );
};